import dayjs from "dayjs";
import { DisableIfCondition, DisableIfContext } from "./types";

const evaluateCondition = (
  condition: DisableIfCondition,
  entity: Record<string, any>,
  context: DisableIfContext,
): boolean => {
  switch (condition) {
    case "futurePublicationDate":
      if (entity.publish_date) {
        return dayjs(entity.publish_date).isAfter(dayjs());
      }
      return true;

    case "obsolete":
      return (
        !!entity.obsolescent_date &&
        dayjs(entity.obsolescent_date).isBefore(dayjs())
      );

    case "notOwner": {
      const corpId = parseInt(context.corporateId || "");
      if (entity.corporate_id?.id) {
        return entity.corporate_id.id !== corpId;
      }
      return context.user?.organization_id !== corpId;
    }

    case "is_standalone":
      return entity.is_standalone === false;

    case "communitySuspended":
      return (
        !entity.enable_initiative_community_flag || !entity.community_discussion
      );

    case "editable":
      return entity.editable === false;

    case "editionOverbooked":
      return entity.remainingPlaces === 0 && entity.loType === "SYNC";

    case "notClassroomActivity": {
      const type = entity.type || entity.learning_object_type;
      return type !== "DA_PHYSICAL_CLASS" && type !== "DA_VIRTUAL_CLASS";
    }

    default:
      return false;
  }
};

export const evaluateDisableIf = (
  conditions: DisableIfCondition[] | undefined,
  entity: Record<string, any>,
  context: DisableIfContext,
): boolean => {
  if (!conditions || conditions.length === 0) return false;
  return conditions.some((c) => evaluateCondition(c, entity, context));
};

export const evaluateHideIf = (
  conditions: DisableIfCondition[] | undefined,
  entity: Record<string, any>,
  context: DisableIfContext,
): boolean => {
  if (!conditions || conditions.length === 0) return false;
  return conditions.some((c) => evaluateCondition(c, entity, context));
};
